/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

import { InputData } from "../data/input-data";
import { InputDataToRSF } from './InputDataToRSF';
import { RSF } from '../data/app-vo';
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { ItemList } from "../constant/item-list";
import { TimerService } from "src/refresh/service/timer-service";
var show = console.log.bind( console );
/////declare let grecaptcha: any;

export class SubmitApplication {

       dataToRsf:InputDataToRSF;

       constructor(private httpClient:HttpClient,
                   private data:InputData, 
                   private timerService:TimerService,
                           items:ItemList ) {

                   this.dataToRsf =  new InputDataToRSF(items);
       }

            /** V3
       private captcha(callback) {
            grecaptcha.ready(function() {
                  grecaptcha.execute(environment.site_key, {action: 'submit'}).then(function(token) {
                        callback(token);
                  });
            });
       }
       */ 
       public submit() {

            this.data.isSubmit = true;
            this.timerService.close();

            let rsf:RSF = this.dataToRsf.create(this.data);
                rsf.captcha = this.data.subject.captcha;

            let url = environment.submit_url;
            //console.log("URL",url);
//if ( url ) return;
            this.httpClient.post(url, rsf)
                .subscribe( resp => {

                            //console.log(resp);

                            if ( !resp ) {
                                   this.errorPage(null);
                                   return;
                            }

                            let  redirectURL = resp['redirectURL'];
                            
                            if ( redirectURL.startsWith("/") ) {
                                  let idx = window.location.href.lastIndexOf("/");
                                  redirectURL = window.location.href.substring(0,idx) + redirectURL;
                            }
                            else {
                                  redirectURL = decodeURIComponent(redirectURL);
                            }
                            
                            window.location.href = redirectURL;
                 }
                 ,
                 error => { 
                          this.errorPage(error);
                 }                 
            );
     }

     private errorPage(error) {

            let idx = window.location.href.lastIndexOf("/");
      
            let url = window.location.href.substring(0,idx) + "/receipt/index.html?error&";
            if ( this.data.subject.language == 'fr' || this.data.subject.language == 'F' ) url += 'F';
            else url += 'E';
            window.location.href = url;
     }
}
